export default __webpack_public_path__ + "static/peopleWithReeddiCapsule-9492afb9793577053df7711de7ea3c81.png";